const toMillis = (date: Date, includeTime: boolean): number => {
  // Returns date with time in UTC
  if (includeTime) {
    return date.getTime()
  }

  // Returns date as it is
  return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
}

const isSameDay = (a: Date, b: Date) =>
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate()

export const toUnixTimestamp = (date: Date, includeTime = false): number => {
  return Math.floor(toMillis(date, includeTime) / 1000)
}

export const toPolicyTimestamp = (date: Date): number => {
  const includeTime = isSameDay(date, new Date())
  return toUnixTimestamp(date, includeTime)
}

export const fromUnixTimestamp = (unix: string | number): Date => {
  return new Date(Number(unix) * 1000)
}
